import Terms from "../components/LegalAndUtilPages/LegalPages/Terms";

const TermsOfUsePage = () => {
  return <Terms />;
};

export default TermsOfUsePage;
